import ValuationStepValidator from '@/interfaces/valuation/ValuationStepValidator'
import {
  ValuationStepData,
  BuildingValuationStepData,
} from '@/interfaces/valuation/ValuationData'
import {
  BuildingStatus,
  BuildingType,
  BuildingReconstruction,
  BuildingAge,
} from '@/interfaces/valuation/types/BuildingValuationStep'
import { PropertyType } from '@/interfaces/valuation/types/PropertyValuationStep'
import { Message, MessageType } from '@/interfaces/app/Message'
import createMessage from '@/services/app/createMessage'
import store from '@/store/'

type BuildingFields = 'BuildingType' | 'BuildingAge' | 'BuildingReconstruction'

export default class BuildingValuationStepValidator extends ValuationStepValidator {
  public isValid: boolean = false

  public validate(data: ValuationStepData): Message[] {
    const stepData = data as BuildingValuationStepData
    const errors: Message[] = []

    if (!this.enumContains(BuildingStatus, stepData.buildingStatus)) {
      errors.push(
        createMessage(
          'Krok 2 - Nesprávně zvolený stav budovy',
          MessageType.Error
        )
      )
    }

    if (
      this.shouldHave('BuildingType', stepData) &&
      !this.enumContains(BuildingType, stepData.buildingType)
    ) {
      errors.push(
        createMessage(
          'Krok 2 - Nesprávně zvolený typ budovy',
          MessageType.Error
        )
      )
    }

    if (
      this.shouldHave('BuildingAge', stepData) &&
      !this.enumContains(BuildingAge, stepData.buildingAge)
    ) {
      errors.push(
        createMessage(
          'Krok 2 - Nesprávně zvolené stáří budovy',
          MessageType.Error
        )
      )
    }

    if (
      this.shouldHave('BuildingReconstruction', stepData) &&
      !this.enumContains(
        BuildingReconstruction,
        stepData.buildingReconstruction
      )
    ) {
      errors.push(
        createMessage(
          'Krok 2 - Nesprávně zvolený stav rekonstrukce',
          MessageType.Error
        )
      )
    }

    if (errors.length === 0) {
      this.isValid = true
      return [createMessage('Krok 2 je vyplněný správně', MessageType.Success)]
    } else {
      this.isValid = false
      return errors
    }
  }

  /**
   * Determines whether object should be present or not
   *
   * @param {BuildingFields} field Fields ID
   * @param {BuildingValuationStepData} data
   *
   * @return {boolean}
   */
  private shouldHave(
    field: BuildingFields,
    data: BuildingValuationStepData
  ): boolean {
    const propertyType: PropertyType =
      store.getters['valuationProcess/propertyType']

    switch (field) {
      case 'BuildingType':
        return propertyType === PropertyType.Flat

      case 'BuildingAge':
        if (data.buildingStatus !== BuildingStatus.Finished) {
          return false
        }
        if (
          propertyType === PropertyType.House ||
          (this.shouldHave('BuildingType', data) &&
            data.buildingType === BuildingType.New)
        ) {
          return true
        } else {
          return false
        }

      case 'BuildingReconstruction':
        if (data.buildingStatus !== BuildingStatus.Finished) {
          return false
        }
        if (
          !this.shouldHave('BuildingAge', data) &&
          this.shouldHave('BuildingType', data)
        ) {
          return true
        } else {
          return false
        }
    }
  }
}
